
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/editorSearch/views/EmptyState/EmptyState.scss.css.virtualfile';
        module.exports = {"footer":"_footer_oe3rm_1","footerLink":"_footerLink_oe3rm_8"};